import { Injectable } from '@angular/core';
import { AutenticacaoService } from './autenticacao.service';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { ToastrService } from 'ngx-toastr';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { throwError, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: "root"
})
export class GlobalInterceptor implements HttpInterceptor {
    
    constructor(
                private autenticacaoService: AutenticacaoService,
                private router: Router,
                private toastr: ToastrService
            ) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

      
        if(this.autenticacaoService.getToken()!= null){

            var headers = {};

            var token = this.autenticacaoService.getToken();
            
            if(request.url.includes(environment.apiURL)){
                var token = this.autenticacaoService.getToken();
                headers = {
                    Authorization: `token ${token}`
                };
            }
            
            request = request.clone({
                url:  request.url,
                setHeaders: headers
            });
        }

        //send the newly created request
        return next.handle(request)
                    .pipe(

                        catchError((error, caught) => {

                            if (error.status === 401) { //Unauthorized
                                
                                this.toastr.warning("Usuário não autenticado");
        
                                //Faz o logout, e redireciona para a página de login
                                this.autenticacaoService.logout();
                                this.router.navigate(['/autenticacao/login']);
        
                                return throwError(error);
        
                            } else if(error.status === 403){ //Forbidden
                                this.toastr.warning("403-Permissão negada para acessar o recurso");
                                this.router.navigate(['/']);
                                return throwError(error);
        
                            } else if(error.status === 404){ //NotFound
                                this.toastr.error("404-Não encontrado");
                                return throwError(error);
        
                            } else if(error.status === 500) {
                                this.toastr.error("500-Erro no servidor: " + error.error.ex);
                                return throwError(error);
        
                            }else if(error.status === 0) {
                                this.toastr.error("Serviço offline, por favor tente novamente mais tarde");
                                return throwError(error);
        
                            }else{
                                return throwError(error);
                            }
        
                       }) as any


                    );
               
    }


}